import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Email, RequestBody} from "../../interfaces/admin.interface";
import {LoggingService} from "../log.service";
import {RestfulService} from "../restful.service";
import {BaseService, EndPoint, ListService} from "../../classes/baseService";
import {ItemRequestBody} from "../../interfaces/item.interface";
import {QuoteData, QuoteInfo} from "../../interfaces/quote.interface";
import {CustOrderData, CustOrderInfo} from "../../interfaces/custOrder.interface";

@Injectable({
    providedIn: 'root'
})
export class CustOrderService extends BaseService<CustOrderInfo, CustOrderData> implements ListService<ItemRequestBody> {

    public static endPoint = new EndPoint('cust-order', true)

    constructor(
        logger: LoggingService,
        restful: RestfulService,
    ) {
        super(logger, restful)
        this.endPoint = CustOrderService.endPoint
    }

    protected override getDefaultDto(): QuoteInfo {
        const obj = new QuoteInfo()
        obj.date = new Date()
        return obj;
    }


    list(reqBody: RequestBody) {
        return this.listImpl(CustOrderService.endPoint.paths.find, reqBody)
    }

    override getRecord(id: number): Observable<any> {
        return this.getRecordImpl(id, CustOrderService.endPoint.paths.findInfo);
    }

    save(reqBody: QuoteData, id?: number) {
        this.saveImpl(reqBody, id != null ? CustOrderService.endPoint.paths.update : CustOrderService.endPoint.paths.create, id)
    }

    public nextCode(date: Date, headquarter: number): Observable<any> {
        const getter = this.post(`/${this.endPoint.baseUrl}/code/next`, {
            date: date,
            headquarter: headquarter
        });
        return getter;
    }

    public states(): Observable<any> {
        const getter = this.get(`/${this.endPoint.baseUrl}/state`);
        return getter;
    }

    public deliver(id: number, request: any): Observable<any> {
        const observable = this.postMultipart(`/${this.endPoint.baseUrl}/${id}/deliver`, request);
        return observable;
    }

    public bom(id: number): Observable<any> {
        const observable = this.post(`/${this.endPoint.baseUrl}/${id}/bom`, {});
        return observable;
    }

}

